<template lang="pug">
.c-reactions-overlay(v-resize-observer="onResize")
</template>
<script>
import { mapState } from 'vuex'
import shuffle from 'lodash/shuffle'
import emojiData from 'emoji-mart/data/twitter.json'
import { getEmojiPosition } from 'lib/emoji'

const MAX_PARTICLE_POOL = 70 // TODO derive from width to have consistent density
const SERVER_REACTIONS_INTERVAL = 1000

export default {
	components: {},
	props: {
		showReactionBar: Boolean
	},
	data () {
		return {
			particlePool: [],
			freeParticles: [],
			overlayHeight: null
		}
	},
	computed: {
		...mapState(['reactions']),
	},
	watch: {
		reactions () {
			if (!this.reactions) return
			// put all reactions in a queue and randomize to get rough averages toghether with the particle pool
			// cap at MAX_PARTICLE_POOL and round up
			let reactions = []
			const totalReactions = Object.values(this.reactions).reduce((acc, count) => acc + count, 0)
			const reactionMultiplier = Math.min(1, MAX_PARTICLE_POOL / totalReactions)
			for (const [reaction, count] of Object.entries(this.reactions)) {
				reactions.push(...Array(Math.ceil(count * reactionMultiplier)).fill(reaction))
			}
			reactions = shuffle(reactions)
			const finalLength = reactions.length
			const distribute = () => {
				if (reactions.length === 0) return
				this.renderReaction(reactions.pop())
				setTimeout(distribute, SERVER_REACTIONS_INTERVAL / finalLength)
			}
			distribute()
		}
	},
	mounted () {
		this.overlayHeight = this.$el.offsetHeight
	},
	methods: {
		renderReaction (id) {
			let element = this.freeParticles.pop()
			if (!element) {
				if (this.particlePool.length < MAX_PARTICLE_POOL) {
					element = document.createElement('div')
					element.classList.add('reaction')
					this.$el.appendChild(element)
					this.particlePool.push(element)
				} else {
					return
				}
			}

			const emoji = emojiData.emojis[id]
			const startingPosition = Math.random()
			const targetHeight = 0.5 * Math.max(0.7, Math.random()) * this.overlayHeight
			element.style['background-position'] = getEmojiPosition(emoji)
			element.style.left = `calc(${startingPosition * 100}% - 24px)`
			const animation = element.animate([
				{opacity: 1, transform: 'translateY(0px)'},
				{opacity: 0, transform: `translateY(-${targetHeight}px)`}
			], {
				duration: 1200 + 500 * Math.random()
			})
			animation.onfinish = () => {
				// onfinish seems to get called twice sometimes?
				if (this.freeParticles.includes(element)) return
				this.freeParticles.push(element)
			}
		},
		onResize () {
			// TODO use reported size from observer
			this.overlayHeight = this.$el.offsetHeight
		}
	}
}
</script>
<style lang="stylus">
.c-reactions-overlay
	position: absolute
	// TODO decopypaste
	bottom: calc(var(--vh100) - 56px - var(--mediasource-placeholder-height))
	right: calc(100vw - var(--sidebar-width) - var(--mediasource-placeholder-width))
	width: var(--mediasource-placeholder-width)
	height: var(--mediasource-placeholder-height)
	pointer-events: none
	overflow: hidden
	z-index: 50
	.reaction
		position: absolute
		bottom: -32px
		height: 28px
		width: @height
		display: inline-block
		background-image: url("~emoji-datasource-twitter/img/twitter/sheets-256/64.png")
		background-size: 5700% 5700%
		image-rendering: -webkit-optimize-contrast
	+below('l')
		bottom: calc(var(--vh100) - 48px - 56px - var(--mediasource-placeholder-height))
		right: calc(100vw - var(--mediasource-placeholder-width))
</style>
